document.addEventListener 'getExtensionId', (e) ->
  if e.detail
    window.CLIPPER_EXTENSION_ID = e.detail
